import React, { useState, useEffect } from "react";
import { Bell } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/Tabs";
import { Button } from "../ui/Button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../ui/Card";
import { DocumentDuplicateIcon, PencilIcon } from "@heroicons/react/24/solid";
import { Textarea } from "../ui/TextArea";
import Badge from "../ui/Badge";
import axios from "../axios/AxiosInstance";
import { EyeIcon } from "@heroicons/react/24/solid";
import { Document, Page } from "react-pdf";
import logo2 from "../assets/img/logo.png";
import { formatJsDate } from "../utils/formatageDate";
import qualifications from "../utils/qualifications";
import {
  MapPin,
  AlertCircle,
  Building,
  ClipboardList,
  Clock,
  GraduationCap,
  Timer,
  UserCheck,
  Plane,
  Users,
  Mail,
  Info,
  Laptop,
  Phone,
  FileText,
  Briefcase,
  CalendarDays,
  UserCircle,
  Calendar,
  Euro,
} from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/Select";
import { Label } from "../ui/Label";
import { Input } from "../ui/Input";
import { CheckBox } from "../ui/Checkbox";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogDescription,
  DialogTitle,
  DialogFooter,
} from "../ui/dialog";
import {
  TableHead,
  TableRow,
  Table,
  TableHeader,
  TableBody,
  TableCell,
} from "../ui/Table";

import { Avatar, AvatarImage, AvatarFallback } from "../ui/Avatar";
import PageHeader from "../ui/PageHeader";

const Annonces = () => {
  const [activeTab, setActiveTab] = useState("actives");
  const [annonces, setAnnonces] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenModalDetails, setIsOpenModalDetails] = useState(false);
  const [isCandidateModalOpen, setIsCandidateModalOpen] = useState(false);
  const [filteredAnnonces, setFilteredAnnonces] = useState([]);
  const [cvData, setCvData] = useState("");
  const [isModalCV, setIsModalCV] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [openDetails, setIsOpenDetails] = useState(false);
  const [numPages, setNumPages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const InfoItem = ({ icon, label, value }) => (
    <div>
      <h3 className="text-lg font-semibold text-gray-800 mb-2 flex items-center">
        <span className="h-5 w-5 mr-2">{icon}</span>
        {label} :
      </h3>
      <p className="text-gray-700 ml-7 whitespace-pre-line">{value}</p>
    </div>
  );

  const [statutOptions, setStatutOptions] = useState([
    "Présélection",
    "Nouveau",
    "En attente",
    "Sélectionné",
    "Entretien tel",
    "RDV Agence",
    "Proposés Client",
    "RDV avec Client",
    "Recruté",
    "Refusé",
  ]);
  const [statutColors, setStatutColors] = useState({
    Présélection: "bg-gray-100 text-gray-700",
    Nouveau: "bg-purple-100 text-purple-700",
    Sélectionné: "bg-yellow-100 text-yellow-700",
    "En attente": "bg-orange-100 text-orange-700",
    Recruté: "bg-green-100 text-green-700",
    Refusé: "bg-red-100 text-red-700",
    "RDV Agence": "bg-pink-100 text-pink-700",
    "Proposés Client": "bg-blue-100 text-blue-700",
    "RDV avec Client": "bg-orange-100 text-orange-700",
    "Entretien tel": "bg-green-100 text-green-700",
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [activeFilterTab, setActiveFilterTab] = useState("Tous");
  const [candidatsFiltres, setCandidatsFiltres] = useState([]);
  const [showCandidats, setShowCandidats] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [selectedAnnonce, setSelectedAnnonce] = useState(null);

  const loadAnnonces = () => {
    axios
      .get("annonces")
      .then((res) => {
        console.log(res.data);
        const updatedAnnonces = res.data.map((annonce) => {
          console.log(annonce.candidats);
          const updatedCandidats = annonce.candidats.map((candidat) => ({
            ...candidat.candidateId,
            statutActuel: "Nouveau",
            date: candidat.date,
          }));
          console.log(updatedCandidats);
          return { ...annonce, candidats: updatedCandidats };
        });

        setAnnonces(updatedAnnonces);
        setFilteredAnnonces(updatedAnnonces);
      })
      .catch((err) => {
        console.error("Erreur de chargement des annonces", err);
      });
  };

  const loadCandidats = (annonceId) => {
    axios
      .get(`annonces/candidats/${annonceId}`)
      .then((res) => {
        console.log(res);
        if (res.data.length) {
          // Ajouter un statut par défaut "Nouveau" si un candidat n'a pas de statut
          const updatedCandidates = res.data.map((candidate) => ({
            ...candidate,
            statutActuel: candidate.statutActuel || "Nouveau", // Si le candidat n'a pas de statut, attribuer "Nouveau"
          }));

          setCandidates(updatedCandidates);
          setShowCandidats(annonceId);
        }
      })
      .catch((e) => console.log(e));
  };

  const showCv = (candidate) => {
    const candidateId = candidate._id;
    setIsLoading(true);
    axios
      .get(`cv/${candidateId}`)
      .then((res) => {
        console.log(res);
        setCvData(res.data.data);
        setSelectedUser(candidate);
        setIsModalCV(true);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDownloadPdf = () => {
    // Generate a temporary anchor element and set the PDF file as its href
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${cvData}`;
    link.download = `${selectedUser.firstname}-${selectedUser.lastname}.pdf`;

    // Simulate a click event to trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDocumentLoadSuccess = ({ numPages }) => {
    const newArray = Array.from({ length: numPages }, (_, index) => index + 1);
    setNumPages(newArray);
  };

  const [countByStatus, setCountByStatus] = useState({
    Tous: 0,
    Présélection: 0,
    Nouveau: 0,
    "En attente": 0,
    Sélectionné: 0,
    "Entretien tel": 0,
    "RDV Agence": 0,
    "Proposés Client": 0,
    "RDV avec Client": 0,
    Recruté: 0,
    Refusé: 0,
  });

  const handleStatutChange = (candidateId, newStatut) => {
    const newCandidates = selectedAnnonce.candidats.map((candidate) => {
      console.log(candidate._id === candidateId);
      return candidate._id === candidateId
        ? { ...candidate, statutActuel: newStatut }
        : candidate;
    });
    console.log(newCandidates);
    setSelectedAnnonce({ ...selectedAnnonce, candidats: newCandidates });
  };

  const getInitials = (prenom, nom) => {
    const firstInitial = prenom ? prenom.charAt(0).toUpperCase() : "";
    const lastInitial = nom ? nom.charAt(0).toUpperCase() : "";
    return `${firstInitial}${lastInitial}`;
  };

  const handleSearch = () => {
    const filtered = annonces.filter(
      (annonce) =>
        annonce.title &&
        annonce.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
        annonce.town &&
        annonce.town.toLowerCase().includes(searchLocation.toLowerCase()),
    );
    setFilteredAnnonces(filtered);
    setCurrentPage(1);
  };

  const resetFilters = () => {
    setSearchTerm("");
    setSearchLocation("");
    setFilteredAnnonces(annonces);
    setCurrentPage(1);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const diffuserAnnonce = (id) => {
    setAnnonces((prev) =>
      prev.map((annonce) =>
        annonce.id === id
          ? { ...annonce, diffusee: !annonce.diffusee }
          : annonce,
      ),
    );
  };

  const archiverAnnonce = (id) => {
    setAnnonces((prev) =>
      prev.map((annonce) =>
        annonce.id === id ? { ...annonce, archivee: true } : annonce,
      ),
    );
  };

  const desArchiverAnnonce = (id) => {
    setAnnonces((prev) =>
      prev.map((annonce) =>
        annonce.id === id ? { ...annonce, archivee: false } : annonce,
      ),
    );
  };

  const annoncesFiltrees = annonces.filter(
    (annonce) =>
      (activeTab === "actives" && !annonce.archivee) ||
      (activeTab === "archivees" && annonce.archivee),
  );

  const totalAnnoncesActives = annonces.filter(
    (annonce) => !annonce.archivee,
  ).length;

  const openModal = () => {
    setIsOpenModal(true);
  };

  const closeModal = () => {
    setIsOpenModal(false);
  };

  const openModalDetails = () => {
    setIsOpenModalDetails(true);
  };

  const closeModalDetails = () => {
    setIsOpenModalDetails(false);
  };

  const openCandidateModal = () => {
    setIsCandidateModalOpen(true);
  };
  const closeCandidateModal = () => {
    setIsCandidateModalOpen(false);
  };

  useEffect(() => {
    loadAnnonces();
  }, []);

  const getPaginatedAnnonces = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredAnnonces.slice(startIndex, endIndex);
  };

  return (
    <main className="container mx-auto py-10 px-6 min-h-screen"> 
      <div className="mb-8 -mt-4 -ml-3">
        <PageHeader
      icon={Bell}
      title="Gestion des annonces d'emploi"
      description="Publiez et actualisez vos offres d’emploi pour attirer les candidats adaptés et faciliter le processus de recrutement."
    />
        
    </div>

      <Tabs
        defaultValue="actives"
        onValueChange={setActiveTab}
        className="w-full"
      >
        <div className="flex justify-between items-center mb-6">
          <TabsList className="bg-white border border-gray-200 rounded-md shadow-sm">
            <TabsTrigger
              value="actives"
              className="px-8 py-2.5 text-sm font-medium"
            >
              Annonces actives
            </TabsTrigger>
            <TabsTrigger
              value="archivees"
              className="px-8 py-2.5 text-sm font-medium"
            >
              Annonces archivées
            </TabsTrigger>
          </TabsList>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label
                htmlFor="keyword"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Mot-clé ou titre
              </label>
              <Input
                id="keyword"
                type="text"
                placeholder=""
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div>
              <label
                htmlFor="location"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Lieu
              </label>
              <Input
                id="searchLocation"
                type="text"
                placeholder=""
                value={searchLocation}
                onChange={(e) => setSearchLocation(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
            <div className="flex items-end">
              <Button
                className="w-full md:w-auto bg-gray-200 hover:bg-gray-300 text-gray-700"
                onClick={resetFilters}
              >
                Réinitialiser les filtres
              </Button>
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button
              className="bg-black hover:bg-black text-white"
              onClick={handleSearch}
            >
              Rechercher
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 ml-2"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </Button>
            <span></span>

            <Button
              className="bg-black hover:bg-black text-white px-6 py-2.5 font-medium text-sm rounded-md shadow-sm transition-colors duration-200"
              onClick={openModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 mr-2"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10 3a1 1 0 00-1 1v5H4a1 1 0 100 2h5v5a1 1 0 102 0v-5h5a1 1 0 100-2h-5V4a1 1 0 00-1-1z"
                  clipRule="evenodd"
                />
              </svg>
              Créer une annonce
            </Button>
          </div>
        </div>

        {isOpenModal && (
          <div className="fixed inset-0  bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white h-5/6 scrollbar-none  p-6 rounded-md shadow-md  w-3/5 relative max-h-screen overflow-y-auto min-h-0">
              <button
                onClick={closeModal}
                className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>

              <h2 className="text-2xl font-bold mb-8 text-left">
                Créer une annonce
              </h2>

              <form>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-5">
                  <div className="space-y-2">
                    <Label htmlFor="client">Site</Label>
                    <Input
                      name="client"
                      id="client"
                      placeholder="Sélectionnez un site"
                      required
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="contact">Contact </Label>
                    <Input
                      name="contact"
                      id="contact"
                      placeholder="Sélectionnez un contact"
                      required
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                  <div className="space-y-2">
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      name="email"
                      type="email"
                      placeholder="email@email.com"
                    />
                  </div>
                  <div className="space-y-2">
                    <Label htmlFor="phone">Téléphone</Label>
                    <Input
                      id="phone"
                      name="phone"
                      type="tel"
                      placeholder="06 12 34 56 78"
                    />
                  </div>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="titre">Intitulé du poste *</Label>
                  <select
                    id="titre"
                    name="titre"
                    required
                    className="w-full p-2 border rounded-md text-sm text-gray-400"
                  >
                    <option value=""> Sélectionnez une qualification</option>
                    {qualifications.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="localisation">Localisation</Label>
                  <Input
                    id="localisation"
                    name="localisation"
                    placeholder="Ex: Paris, France ou Télétravail"
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="description">Description du poste</Label>
                  <Textarea
                    id="description"
                    name="description"
                    placeholder="Décrivez le poste, les missions, le profil recherché..."
                    rows={5}
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="profil">Profil recherché</Label>
                  <Textarea
                    id="profil"
                    name="profil"
                    placeholder="Ex: React, gestion de projet, anglais courant"
                    rows={3}
                  />
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Niveau de qualifications</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Sélectionnez un niveau de qualification " className="text-gray-100" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Sans diplôme</SelectItem>
                      <SelectItem value="CDI">BEP/CAP</SelectItem>
                      <SelectItem value="CDD">
                        Employé/Opérateur/Ouvrier/Bac
                      </SelectItem>
                      <SelectItem value="Intérim">
                        Technicien/Employé/Bac+2
                      </SelectItem>
                      <SelectItem value="Stage">
                        Agent de maitrise/Bac+3/Cadre
                      </SelectItem>
                      <SelectItem value="Apprentissage">
                        Ingénieur/Cadre/Bac+5
                      </SelectItem>
                      <SelectItem value="Freelance">Cadre dirigeant</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Expérience demandée</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Sélectionnez un niveau d'expérience " />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Moins d'1 an</SelectItem>
                      <SelectItem value="CDI">1 à 7 ans</SelectItem>
                      <SelectItem value="CDD">Plus de 7 ans</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Type de contrat</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Sélectionnez un type de contrat" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">CDI</SelectItem>
                      <SelectItem value="CDD">CDD</SelectItem>
                      <SelectItem value="Intérim">Intérim</SelectItem>
                      <SelectItem value="Stage">Stage</SelectItem>
                      <SelectItem value="Apprentissage">
                        Apprentissage
                      </SelectItem>
                      <SelectItem value="Freelance">Freelance</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="salaire">Fourchette de salaire</Label>
                  <Input
                    id="salaire"
                    name="salaire"
                    placeholder="Ex: 45k€ - 55k€"
                  />
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Base salaire</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Sélectionnez une base" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Heure</SelectItem>
                      <SelectItem value="CDD">Jour </SelectItem>
                      <SelectItem value="Intérim">Semaine</SelectItem>
                      <SelectItem value="Stage">Mois</SelectItem>
                      <SelectItem value="Apprentissage">An</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="dateDebutSouhaitee">
                    Date de début souhaitée
                  </Label>
                  <Input
                    id="dateDebutSouhaitee"
                    name="dateDebutSouhaitee"
                    placeholder="Ex: ASAP, JJ/MM/AAAA"
                  />
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Déplacement</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Déplacement" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Pas de déplacement</SelectItem>
                      <SelectItem value="CDD">Départemental</SelectItem>
                      <SelectItem value="Intérim">Régional</SelectItem>
                      <SelectItem value="Stage">National</SelectItem>
                      <SelectItem value="Apprentissage">
                        International
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Temps de travail</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Temps de travail" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Temps complet</SelectItem>
                      <SelectItem value="CDD">Temps partiel</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="typeContrat">Télétravail</Label>
                  <Select name="typeContrat">
                    <SelectTrigger id="typeContrat" className="text-gray-400">
                      <SelectValue placeholder="Télétravail" />
                    </SelectTrigger>
                    <SelectContent className="bg-white">
                      <SelectItem value="CDI">Pas de télétravail</SelectItem>
                      <SelectItem value="CDD">Occasionnel </SelectItem>
                      <SelectItem value="CDD">Partiel</SelectItem>
                      <SelectItem value="CDD">Total (100%)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>

                <div className="space-y-2 mb-4">
                  <Label htmlFor="competencesPrincipales">
                    Informations Complémentaires
                  </Label>
                  <Textarea
                    id="competencesPrincipales"
                    name="competencesPrincipales"
                    placeholder="Informations Complémentaires"
                    rows={3}
                  />
                </div>

                <div className="mt-6 flex justify-end">
                  <Button
                    type="button"
                    variant="outline"
                    className="text-gray-600 border-gray-300 mr-5"
                    onClick={closeModal}
                  >
                    Fermer
                  </Button>

                  <Button
                    type="submit"
                    className="bg-black text-white flex-justify-center"
                  >
                    Générer l'annonce
                  </Button>
                </div>
              </form>
            </div>
          </div>
        )}
        {isOpenModalDetails && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-md shadow-md max-w-3xl w-full relative max-h-screen flex flex-col">
              <div className="overflow-y-auto p-6 space-y-6">
                <Card className="max-w-3xl mx-auto shadow-lg border border-gray-200 rounded-lg">
                  <CardHeader className="bg-gray-100 p-6 rounded-t-lg">
                    <CardTitle className="text-3xl md:text-4xl font-bold text-blue-700">
                      {selectedAnnonce.title}
                    </CardTitle>
                    {selectedAnnonce.companyName && (
                      <CardDescription className="text-lg text-gray-600 flex items-center pt-2">
                        <Building className="h-5 w-5 mr-2 text-blue-600" />
                        {selectedAnnonce.companyName}
                      </CardDescription>
                    )}
                  </CardHeader>

                  <CardContent className="space-y-8 p-6">
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center">
                        <ClipboardList className="h-6 w-6 mr-3 text-blue-600" />
                        Description du poste :
                      </h3>
                      <p className="text-gray-700 ml-9 whitespace-pre-line">
                        {selectedAnnonce.description}
                      </p>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center">
                        <Briefcase className="h-6 w-6 mr-3 text-blue-600" />
                        Profil recherché :
                      </h3>
                      <p className="text-gray-700 ml-9 whitespace-pre-line">
                        {selectedAnnonce.profilRecherche}
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4 pt-4 border-t border-gray-200">
                      <InfoItem
                        icon={<Users className="text-blue-600" />}
                        label="Client"
                        value={selectedAnnonce.client.companyName}
                      />
                      <InfoItem
                        icon={<Users className="text-blue-600" />}
                        label="Contact Client"
                        value={`${selectedAnnonce.client.contacts[0].title} ${selectedAnnonce.client.contacts[0].lastname} ${selectedAnnonce.client.contacts[0].firstname}
  ${selectedAnnonce.client.contacts[0].email}\n${selectedAnnonce.client.contacts[0].phone}`}
                      />

                      <InfoItem
                        icon={<MapPin className="text-blue-600" />}
                        label="Lieu"
                        value={selectedAnnonce.localisation}
                      />
                      <InfoItem
                        icon={<Briefcase className="text-blue-600" />}
                        label="Type de contrat"
                        value={selectedAnnonce.jobType}
                      />
                      <InfoItem
                        icon={<Clock className="text-blue-600" />}
                        label="Expérience"
                        value={selectedAnnonce.experience}
                      />
                      <InfoItem
                        icon={<GraduationCap className="text-blue-600" />}
                        label="Niveau de qualification"
                        value={selectedAnnonce.niveauQualification}
                      />
                      <InfoItem
                        icon={<Timer className="text-blue-600" />}
                        label="Temps de travail"
                        value={selectedAnnonce.tempTravail}
                      />
                      <InfoItem
                        icon={<Laptop className="text-blue-600" />}
                        label="Télétravail"
                        value={selectedAnnonce.presence}
                      />
                      <InfoItem
                        icon={<Euro className="text-blue-600" />}
                        label="Salaire"
                        value={`${selectedAnnonce.salaire} ${selectedAnnonce.baseSalary}`}
                      />
                      <InfoItem
                        icon={<Calendar className="text-blue-600" />}
                        label="Date de début souhaitée"
                        value={selectedAnnonce.dateDebutSouhaitee}
                      />
                      <InfoItem
                        icon={<Plane className="text-blue-600" />}
                        label="Déplacements"
                        value={selectedAnnonce.deplacement}
                      />

                      <InfoItem
                        icon={<Info className="text-blue-600" />}
                        label="Informations complémentaires"
                        value={selectedAnnonce.informationsComplementaires}
                      />
                    </div>
                  </CardContent>

                  <CardFooter className="flex flex-col items-center p-6 bg-gray-100 rounded-b-lg">
                    <Button
                      className="justify-items-center"
                      variant="outline"
                      onClick={closeModalDetails}
                    >
                      Fermer
                    </Button>

                    <br></br>
                  </CardFooter>
                </Card>
              </div>
            </div>
          </div>
        )}
        {isLoading && (
          <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-[9999]">
            <img
              src={logo2}
              alt="Chargement..."
              className="w-20 h-20 animate-spin duration-1015"
            />
          </div>
        )}

        {isModalCV && (
          <div className="flex items-stretch absolute top-0 min-h-screen  left-0 right-0 z-30 ">
            <div className="grow flex flex-col  items-center justify-center py-6 bg-black bg-opacity-70 min-h-screen">
              <div className="flex items-center my-3 justify-center space-x-4">
                <p
                  className="cursor-pointer bg-white px-2 py-1 text-black rounded-md border border-black"
                  onClick={handleDownloadPdf}
                >
                  Telechargez le cv
                </p>
                <p
                  className="cursor-pointer bg-white px-2 py-1 text-black rounded-md border border-black"
                  onClick={() => setIsModalCV(false)}
                >
                  Fermer
                </p>
              </div>
              <Document
                file={`data:application/pdf;base64,${cvData}`}
                onLoadSuccess={handleDocumentLoadSuccess}
              >
                {numPages.map((x, idx) => {
                  return <Page scale={5 / 3} key={idx} pageNumber={idx + 1} />;
                })}
              </Document>
            </div>
          </div>
        )}
        {selectedAnnonce && (
          <Dialog
            open={isCandidateModalOpen}
            onOpenChange={(open) => setIsCandidateModalOpen(open)}
            key={selectedAnnonce?._id}
          >
            <DialogContent className="max-w-8xl h-[90vh] flex flex-col p-0 bg-white shadow-lg rounded-lg">
              <DialogHeader className="p-6 pb-4 border-b bg-gray-100 rounded-t-lg">
                <DialogTitle className="text-2xl font-semibold text-gray-900">
                  Gestion des candidatures
                </DialogTitle>
                <DialogDescription className="text-sm text-gray-600">
                  Pour l'annonce :{" "}
                  <span className="font-medium text-blue-600">
                    {selectedAnnonce
                      ? selectedAnnonce.title
                      : "Chargement..."}{" "}
                  </span>
                </DialogDescription>
              </DialogHeader>

              <div className="flex-grow overflow-y-auto p-6 pt-0">
                <Tabs
                  value={activeFilterTab}
                  onValueChange={(value) => setActiveFilterTab(value)}
                  className="sticky top-0 bg-white z-10 pt-4 pb-2 mb-4 border-b"
                >
                  <TabsList className="grid w-full grid-cols-5 sm:grid-cols-10 h-auto flex-wrap justify-start gap-5">
                    <TabsTrigger
                      value="Tous"
                      className="text-xs px-3 py-1.5 h-auto data-[state=active]:bg-indigo-100 data-[state=active]:text-indigo-700"
                    >
                      Tous ({countByStatus["Tous"] || 0})
                    </TabsTrigger>
                    {statutOptions.map((statut) => (
                      <TabsTrigger
                        key={statut}
                        value={statut}
                        className="text-xs px-3 py-1.5 h-auto data-[state=active]:bg-indigo-100 data-[state=active]:text-indigo-700 whitespace-nowrap"
                      >
                        {statut} ({countByStatus[statut] || 0})
                      </TabsTrigger>
                    ))}
                  </TabsList>
                </Tabs>

                {candidatsFiltres === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-gray-500">
                    <Briefcase size={48} className="mb-4" />
                    <p className="text-xl font-medium">
                      Aucune candidature pour cette annonce.
                    </p>
                    <p>
                      Revenez plus tard ou partagez l'annonce pour recevoir des
                      candidatures.
                    </p>
                  </div>
                ) : (
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead className="w-[250px]">Candidat</TableHead>
                        <TableHead>Contact</TableHead>
                        <TableHead className="w-[180px]">Statut</TableHead>
                        <TableHead>Infos Clés</TableHead>
                        <TableHead className="text-right">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {selectedAnnonce.candidats.map((candidate, idx) => (
                        <TableRow key={idx} className="hover:bg-gray-50">
                          <TableCell>
                            <div className="flex items-center space-x-3">
                              <Avatar className="h-10 w-10 border">
                                <AvatarImage
                                  src={candidate.email}
                                  alt={`${candidate.lastName}`}
                                />
                                <AvatarFallback className="bg-gray-200 text-gray-600">
                                  {getInitials(candidate.firstname)}{" "}
                                  {getInitials(candidate.lastname)}
                                </AvatarFallback>
                              </Avatar>
                              <div>
                                <div className="font-medium">
                                  {candidate.firstname} {candidate.lastname}
                                </div>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            <div className="flex flex-col space-y-1">
                              <a
                                href={`mailto:${candidate.email}`}
                                className="text-xs text-blue-600 hover:underline flex items-center"
                              >
                                <Mail size={14} className="mr-1.5" />{" "}
                                {candidate.email}
                              </a>
                              {candidate.phone && (
                                <span className="text-xs text-gray-600 flex items-center">
                                  <Phone size={14} className="mr-1.5" />{" "}
                                  {candidate.phone}
                                </span>
                              )}
                            </div>
                          </TableCell>
                          <TableCell>
                            <Select
                              onValueChange={(e) =>
                                handleStatutChange(candidate._id, e)
                              }
                              value={candidate.statutActuel}
                            >
                              <SelectTrigger
                                className={`h-8 text-xs ${
                                  statutColors[candidate.statutActuel] ||
                                  "bg-gray-100 text-gray-800"
                                } border-none font-medium`}
                              >
                                <SelectValue />
                              </SelectTrigger>
                              <SelectContent>
                                {statutOptions.map((statut) => (
                                  <SelectItem
                                    key={statut}
                                    value={statut}
                                    className={`text-xs ${
                                      statutColors[statut] ||
                                      "bg-gray-100 text-gray-800"
                                    }`}
                                  >
                                    {statut}
                                  </SelectItem>
                                ))}
                              </SelectContent>
                            </Select>
                          </TableCell>
                          <TableCell className="text-xs">
                            <div className="flex items-center text-gray-600 mb-0.5">
                              <CalendarDays
                                size={14}
                                className="mr-1.5 text-gray-400"
                              />{" "}
                              Candidature le : {formatJsDate(candidate.date)}
                            </div>
                            {candidate.experience && (
                              <div className="flex items-center text-gray-600 mb-0.5">
                                <Briefcase
                                  size={14}
                                  className="mr-1.5 text-gray-400"
                                />{" "}
                                Exp: {candidate.experience}
                              </div>
                            )}
                            {candidate.pretentionsSalariales && (
                              <div className="flex items-center text-gray-600">
                                <Euro
                                  size={14}
                                  className="mr-1.5 text-gray-400"
                                />{" "}
                                {candidate.pretentionsSalariales}
                              </div>
                            )}
                          </TableCell>
                          <TableCell className="text-right">
                            {candidate && (
                              <Button
                                variant="outline"
                                size="sm"
                                asChild
                                className="mr-2 h-8 px-2"
                                onClick={() => showCv(candidate)}
                              >
                                <a>
                                  <FileText size={14} className="mr-1" /> CV
                                </a>
                              </Button>
                            )}
                            <Button
                              variant="outline"
                              size="sm"
                              className="h-8 px-2"
                              onClick={() =>
                                (window.location.href = `mailto:${candidate.candidate.email}?subject=Réponse à votre candidature pour ${selectedAnnonce.title}`)
                              }
                            >
                              <Mail size={14} className="mr-1" /> Contacter
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </div>

              <DialogFooter className="p-6 pt-4 border-t">
                <Button variant="outline" onClick={closeCandidateModal}>
                  Fermer
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        )}

        <TabsContent value="actives" className="mt-0">
          <div className="mb-8 bg-white p-6 rounded-lg shadow-sm border border-gray-100">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center">
              <span className="text-2xl font-bold text-indigo-600 mr-2">
                {totalAnnoncesActives}
              </span>
              annonces en cours de diffusion sur l'application
            </h2>
          </div>

          <div className="space-y-6">
            {getPaginatedAnnonces().map((annonce) => (
              <Card
                key={annonce.id}
                className="w-full overflow-hidden border-gray-200 shadow-md hover:shadow-lg transition-shadow duration-300"
              >
                <CardContent className="p-0">
                  <div className="p-6 border-b border-gray-100">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-xl font-bold text-gray-800">
                          {annonce.title}
                        </h3>
                        <div className="flex items-center mt-2">
                          <p className="text-gray-600">{annonce.town}</p>
                        </div>
                        <br></br>
                        <Badge
                          variant="outline"
                          className="bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border-indigo-200 px-4 py-1.5 text-sm font-medium rounded-full cursor-pointer transition-colors duration-200"
                          onClick={() => {
                            setSelectedAnnonce(annonce);
                            loadCandidats(annonce._id);
                            setIsCandidateModalOpen(true);
                          }}
                        >
                          {annonce.candidats?.length || 0} candidature(s)
                        </Badge>
                      </div>

                      <div className="flex flex-col space-y-3">
                        <div className="flex items-center space-x-2">
                          {!annonce.diffusee && (
                            <PencilIcon
                              className="h-5 w-5 text-blue-500 cursor-pointer"
                              title="Voir l'annonce"
                            />
                          )}
                          <span></span>
                          {!annonce.diffusee && (
                            <EyeIcon
                              className="h-5 w-5 text-green-500 cursor-pointer"
                              title="Voir l'annonce"
                              onClick={() => {
                                setSelectedAnnonce(annonce);
                                //setIsOpenDetails(true)
                                setIsOpenModalDetails(true);
                              }}
                            />
                          )}
                          <span></span>
                          {!annonce.diffusee && (
                            <DocumentDuplicateIcon
                              className="h-5 w-5 text-black -500 cursor-pointer"
                              title="Voir l'annonce"
                            />
                          )}

                          <Button
                            onClick={() => diffuserAnnonce(annonce.id)}
                            className={
                              annonce.diffusee
                                ? "text-white bg-green-600 hover:bg-green-700 shadow-xm w-15"
                                : "text-white bg-red-600 hover:bg-red-700 shadow-sm w-15"
                            }
                            size="sm"
                          >
                            {annonce.diffusee ? "Diffusée" : "Non diffusée"}
                          </Button>
                        </div>

                        <div className="flex items-center space-x-2 justify-end">
                          <Button
                            onClick={() => archiverAnnonce(annonce.id)}
                            variant="outline"
                            size="sm"
                            className="border-gray-300 hover:bg-gray-100 text-gray-800 w-25"
                          >
                            Archiver
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-11 gap-3 text-center">
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1">Présélection</div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-red-300 rounded-md w-fit">
                        Tous
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-purple-300 rounded-md w-fit">
                        Nouveau
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-orange-100 rounded-md w-fit">
                        En attente
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-yellow-200 rounded-md w-fit">
                        Sélectionné
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-green-200 rounded-md w-fit">
                        Entretien tel
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-pink-300 rounded-md w-fit">
                        RDV Agence
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-blue-300 rounded-md w-fit">
                        Proposés Client
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-orange-400 rounded-md w-fit">
                        RDV avec Client
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-green-400 rounded-md w-fit">
                        Recruté
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                    <div className="p-2 border rounded text-sm">
                      <div className="font-semibold mb-1 bg-red-500 rounded-md w-fit">
                        Refusé
                      </div>
                      <div>
                        <p>test</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}

            {annoncesFiltrees.length === 0 && (
              <div className="p-12 text-center bg-white rounded-lg border border-gray-200 shadow-sm">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-16 w-16 mx-auto mb-4 text-gray-300"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="text-xl font-medium text-gray-900 mb-2">
                  Aucune annonce active
                </h3>
                <p className="text-gray-500 mb-6">
                  Créez une nouvelle annonce pour commencer le recrutement.
                </p>
              </div>
            )}
          </div>
        </TabsContent>
      </Tabs>
    </main>
  );
};

export default Annonces;
